import { render } from "./CurriculumVita.vue?vue&type=template&id=15daa288"
import script from "./CurriculumVita.vue?vue&type=script&lang=js"
export * from "./CurriculumVita.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__